<!--
  Issue #410: company-paid end users' plans are managed by their company
  account, so this page's self-service plan cards/CTAs don't apply to them.
  The route itself is already blocked by PricingEligibilityGuardService —
  this is the belt-and-braces render guard for the embedded (non-routed)
  onboarding usage; see PlansDetailsComponent.isCompanyEndUser.
-->
<div class="container sky-background not-eligible" *ngIf="isCompanyEndUser">
  <app-empty-state
    icon="icon-ico-info"
    heading="Your plan is managed by your company"
    subtext="Contact your company admin to make changes to your plan."
  ></app-empty-state>
</div>

<div class="container sky-background" [class.onboarding]="onboarding" *ngIf="!isCompanyEndUser">
  <div style="display:flex; justify-content:center" *ngIf="!onboarding" class="text-center">
    <h1 class="text-center section-title dark-purple row">
      <span class="font-weight-bold dark-purple save-day">UPGrade your account </span>
      <br /><br />
    </h1>
    <br />
  </div>

  <div style="display:flex; justify-content:center">
    <!-- QA #593 F-7: actualPlanDescription() returns undefined while the
         plan is still loading (e.g. right after a sign-in replay). Wait for
         it instead of rendering "You are currently on the" with a blank
         plan name. -->
    <h2 class="text-center row in-person" *ngIf="!onboarding && actualPlanDescription()">
      You are currently on the <span class="plan"> {{ actualPlanDescription() }} </span>
      <span *ngIf="onTrial" class="trial"> 14-day Trial</span>
    </h2>
    <br />
  </div>

  <div class="fms-onboarding-switch-wrapper" *ngIf="onboarding">
    <button
      type="button"
      class="fms-onboarding-billed-type"
      [ngClass]="{ 'fms-checked': !checked }"
      (click)="setValue(false)"
    >
      Billed Yearly
      <span>Save up to <strong>35%</strong></span>
    </button>
    <button
      type="button"
      class="fms-onboarding-billed-type"
      [ngClass]="{ 'fms-checked': checked }"
      (click)="setValue(true)"
    >
      Billed Monthly
      <span>No Contracts</span>
    </button>
    <!-- <label class="switch">
      <input type="checkbox"
             [checked]="checked"
             (change)="setValue($event)" />
      <span class="slider round"></span>
    </label> -->
  </div>

  <div class="switch-wrapper" *ngIf="!onboarding">
    <p>Billed Yearly</p>
    <!-- vng-toggle replaces the hand-built label.switch > checkbox + span.slider
         CSS switch, matching new-plan.component.html's existing usage.
         setValue() already accepts a boolean (see plans-details.component.ts). -->
    <vng-toggle [(ngModel)]="checked" (changed)="setValue($event)" color="accent"
                ariaLabel="Billed Monthly"></vng-toggle>
    <p>Billed Monthly</p>
  </div>

  <div style="display:flex; justify-content:center" *ngIf="!onboarding" class="save-label">
    <div class="arrow">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_14036_334395)">
          <path
            d="M25.6127 15.8245L24.9718 16.0636L24.3705 16.3168L23.718 16.4621L23.0654 16.6076L22.4128 16.7531L21.7463 16.9381L21.0692 16.9631L20.4176 17.0418L19.7394 17.1334L19.0623 17.1583L18.4001 17.0769L17.737 17.062L17.0595 17.0871L16.3987 16.939L15.7508 16.8177L15.0752 16.7098L14.4554 16.5089L13.7806 16.4005L13.1339 16.1466L12.5151 15.8792L11.9226 15.5995L11.3169 15.2928L10.7244 15.013L10.1468 14.6269L9.59634 14.2279L9.05816 13.8562L8.57503 13.392L8.06487 12.9409L7.55466 12.4896L7.13818 11.9608L6.72244 11.4315L6.30668 10.9023L5.89098 10.373L5.54184 9.77907L5.20657 9.21151L4.8845 8.60463L4.62887 7.99917L4.38726 7.35399L4.13242 6.74807L3.86373 6.11582L3.74192 5.44665L3.50031 4.80146L3.41863 4.14618L3.17701 3.50099L3.14793 2.82078L3.06548 2.16595"
            stroke="#2A1E36"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M0.594294 5.58994L0.843997 4.94218L1.10599 4.32169L1.42039 3.74235L1.6701 3.09459L1.99851 2.47551L2.30063 1.8689L2.61504 1.28956L3.1926 1.67564L3.78418 2.02199L4.33372 2.48754L4.95237 2.82097L5.52994 3.20705L6.0935 3.63287L6.64399 4.03188"
            stroke="#2A1E36"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_14036_334395">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
    <h3 class="text-center row save-price">Save up to 35% with Yearly</h3>
  </div>

  <!-- issue #600 AC-1/AC-4: the plans grid renders one of three mutually
       exclusive states. "loading" covers both the initial mount and a retry
       in flight; "error" replaces the app's generic /session/error redirect
       with an in-page block that keeps the header/toggle above visible and
       offers Retry; "ready" is today's unchanged card grid. -->
  <div class="plans-loading" data-testid="plans-loading" *ngIf="plansLoadState === 'loading'">
    <ngx-skeleton-loader
      count="3"
      appearance="line"
      [theme]="{
        'border-radius': '8px',
        height: '420px',
        width: '300px',
        margin: '0 12px',
        display: 'inline-block'
      }"
    ></ngx-skeleton-loader>
  </div>

  <div
    class="container sky-background not-eligible plans-load-error"
    data-testid="plans-load-error"
    role="alert"
    *ngIf="plansLoadState === 'error'"
  >
    <app-empty-state
      icon="icon-ico-info"
      heading="We couldn't load our plans"
      subtext="Please check your connection and try again."
    ></app-empty-state>
    <!-- QA #602 F-1: EmptyStateComponent's icon is sized by the shared global
         `.empty-state svg { height:100% !important }` rule (app.scss), which
         only resolves against a defined parent height — svg-icon-sprite has
         none, so unclamped it rendered at its intrinsic 500x500, pushed this
         button/the heading below the fold, and painted over the button. The
         `.plans-load-error` override below (this component's stylesheet)
         caps the icon to a sensible size scoped to this call site, without
         touching the shared .empty-state rule other pages (shortcuts,
         dashboard, flyshare) also use. Capping the icon removes the overflow,
         so the button no longer needs the position:relative/z-index it used
         to. -->
    <div style="display:flex; justify-content:center">
      <button
        vng-button
        variant="primary"
        type="button"
        data-testid="plans-load-retry"
        (click)="retryPlansLoad()"
      >
        Try again
      </button>
    </div>
  </div>

  <div
    style="display:flex; justify-content:center"
    class="plans"
    data-testid="plans-ready-region"
    tabindex="-1"
    *ngIf="plansLoadState === 'ready'"
  >
    <!-- Freemium -->
    <div
      style="display:flex; flex-direction:column"
      *ngFor="let plan of filteredPlans()"
      class="plan white-background"
      [class.selected]="plan.popular"
    >
      <!-- fix(L11): the surrounding `.plan.white-background` div owns the plan's
           frame (border + shadow + radius + white fill + sizing). This card is
           only the content wrapper, so it must draw nothing of its own —
           `ghost` gives a transparent, border-less, shadow-less box, and
           `padding="none"` switches off vng-card's built-in 24px inset so the
           single 32px host padding is the whole inset (see the scss). -->
      <vng-card variant="ghost" padding="none" class="mat-card-3">
        <div class="top-tag" *ngIf="plan.popular || currentPlan(plan) || showTrial(plan) || isTrialingOwnPlan(plan)">
          <div class="top-tag-item most-popular" *ngIf="!currentPlan(plan) && plan.popular && !checked">
            MOST POPULAR
          </div>
          <div *ngIf="showTrial(plan)" class="top-tag-item most-popular" data-testid="plan-trial-ribbon">START MY FREE TRIAL</div>
          <div *ngIf="currentPlan(plan)" class="top-tag-item current">Your Current Plan</div>
          <div *ngIf="isTrialingOwnPlan(plan)" class="top-tag-item trial">Your 14-Day Trial</div>
        </div>
        <h5 class="card-title text-center plan-name" style="padding: 0">
          {{ plan.name }}
        </h5>
        <br />
        <!-- issue #603 AC-1/AC-2/AC-4: a plan absent from a valid
             v1/subscriptions/plans body at the current billing interval
             never shows a $0 price or a live "Choose …" button — it shows
             the "Contact sales" block instead. A card the visitor is
             already subscribed to (currentPlan()) keeps its disabled "Your
             Current Plan" button rather than switching to the CTA (AC-4). -->
        <ng-container *ngIf="!isContactSalesOnly(plan); else contactSalesCard">
          <p class="text-center">
            <ng-container *ngIf="discountedPrice(plan) as discounted; else fullPriceOnly">
              <span class="h2 plan-pricing text-center coupon-price">${{ discounted }}/mo</span>
              <span class="plan-pricing-full-strike">${{ displayedPrice(plan) }}/mo</span>
              <span class="plan-coupon-code">with code {{ pendingCouponCode }}</span>
              <span class="plan-cost">
                {{
                  checked ? "*Billed monthly" : "*Billed annually at $" + discountedAnnualTotal(plan) + " per user"
                }}</span
              >
            </ng-container>
            <ng-template #fullPriceOnly>
              <span class="h2 plan-pricing text-center">${{ displayedPrice(plan) }}/mo{{ !checked ? "*" : "" }}</span>
              <span class="plan-cost">
                {{
                  checked ? "*Billed monthly" : "*Billed annually at $" + displayedPrice(plan, true) + " per user"
                }}</span
              >
            </ng-template>
            <small class="description text-center" [innerHtml]="plan.description"></small>
          </p>

          <div style="display:flex; justify-content:center">
            <button
              #buttons
              class="btn btn-block plan-btn"
              [class.orange-btn]="plan.popular"
              [disabled]="currentPlan(plan)"
              (click)="selectPlan(plan, !checked)"
            >
              {{
                showTrial(plan)
                  ? "Start My Free 14-Day Trial"
                  : currentPlan(plan)
                  ? "Your Current Plan"
                  : isTrialingOwnPlan(plan)
                  ? "Subscribe to " + plan.name
                  : plan.button
              }}
            </button>
          </div>
        </ng-container>

        <ng-template #contactSalesCard>
          <div data-testid="plan-contact-sales">
            <p class="text-center">
              <span class="h2 plan-pricing text-center">Contact sales</span>
              <span class="plan-cost">This plan is available through our sales team.</span>
              <small class="description text-center" [innerHtml]="plan.description"></small>
            </p>

            <div style="display:flex; justify-content:center">
              <button
                *ngIf="currentPlan(plan); else contactSalesCta"
                #buttons
                class="btn btn-block plan-btn"
                [disabled]="true"
              >
                Your Current Plan
              </button>
              <ng-template #contactSalesCta>
                <button
                  vng-button
                  variant="primary"
                  type="button"
                  data-testid="plan-contact-sales-link"
                  (click)="contactSales()"
                >
                  Contact sales
                </button>
              </ng-template>
            </div>
          </div>
        </ng-template>

        <ul class="features-ul padding-inline-end">
          <li *ngFor="let dot of plan.dots; index as i">
            <span [innerHTML]="dot"></span>
            <ul *ngIf="i === 0">
              <li>
                <b>{{ plan.freeAIPrompts }}</b> Prompts Per Day
              </li>
            </ul>
          </li>
        </ul>
        <ul class="features-ul without-dots">
          <h3 class="margin-left-0">
            <span class="key-features">Key Features </span>
          </h3>
          <li *ngFor="let key of plan.keys" [class.special]="plan.key === 'sales-pro'" style="display: flex">
            <div>
              <svg-icon-sprite
                class="menu-icon check-icon"
                width="15px"
                height="15px"
                viewBox="0 0 80 80"
                src="icon-ico-correct"
              >
              </svg-icon-sprite>
            </div>
            <span [innerHtml]="key"></span>
          </li>
        </ul>
      </vng-card>
    </div>
  </div>
  <small
    class="bottom-text"
    data-fms-heap="onboarding9-pricing-comparison-table"
    style="padding: 20px 0 30px 0; text-align: center"
    >For further plan details and FAQs please visit the
    <a href="https://vengreso.com/flymsg-pricing" target="_blank">FlyMSG Pricing Page</a></small
  >
</div>
